import PERM from 'constants/core/perm.const';
import USER_ROLE from 'constants/role';
import { selectAccessHasLockToken, selectAccessPerms } from 'selectors/access.selectors';
import { checkHideDetailsForReceptionist } from 'selectors/currentSalon.selectors';
import selectEffectiveUserRole from 'selectors/selectEffectiveUserRole';

const isEffectiveReceptionist = (state) => selectEffectiveUserRole(state) === USER_ROLE.receptionist;

const selectHasCustomPermission = (state, permission) => {
  const perms = selectAccessPerms(state);
  return Array.isArray(perms) && perms.includes(permission);
};

export const selectCanViewClientDetails = (state) => {
  if (selectAccessHasLockToken(state)) {
    return selectHasCustomPermission(state, PERM.canViewClientDetails);
  }

  if (isEffectiveReceptionist(state) && checkHideDetailsForReceptionist(state)) return false;
  return true;
};

export const selectCanEditClient = (state) => {
  if (!selectAccessHasLockToken(state)) return true;
  return selectHasCustomPermission(state, PERM.canEditClients);
};

export const selectCanDeleteClients = (state) => {
  if (selectAccessHasLockToken(state)) return selectHasCustomPermission(state, PERM.canDeleteClients);
  return !isEffectiveReceptionist(state);
};

export const selectHideClientDetails = (state) => !selectCanViewClientDetails(state);

export const selectHasClientContactFieldAccess = (state) => selectCanViewClientDetails(state) || selectCanEditClient(state);
